import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Declare from '/src/data/auto-generated/venia-ui/lib/targets/venia-ui-declare.md';
import RichContentRendererList from '/src/data/auto-generated/venia-ui/lib/targets/RichContentRendererList.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "venia-targets"
    }}>{`Venia targets`}</h1>
    <p>{`This page lists the Targets declared in the Venia UI package.`}</p>
    <h2 {...{
      "id": "accessing-the-targets"
    }}>{`Accessing the targets`}</h2>
    <p>{`Access these in your intercept files by calling `}<inlineCode parentName="p">{`targets.of('@magento/venia-ui')`}</inlineCode>{` on the TargetProvider object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`/* my-custom-interceptors.js */

module.exports = (targets) => {
  const veniaTargets = targets.of("@magento/venia-ui");
};
`}</code></pre>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://github.com/magento-research/pwa-studio-target-experiments"
      }}>{`PWA Studio Target Experiments`}</a>{` project repository for documented examples of extensions that use PWA Studio's extensibility framework.`}</p>
    {/*
     The reference doc content is generated automatically from the source code.
     To update this section, update the doc blocks in the source code
     */}

    <Declare mdxType="Declare" />
    <RichContentRendererList mdxType="RichContentRendererList" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      